// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1NXw8","large":"styles_large__3NPw9"};